export const HEADER_TEXT_BASE_FONT_SIZE = 1.75;
